var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdgeDashed = function SvgEdgeDashed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.037 19.021 3.5 21.5l-1-1 2.476-2.54zm3.859-3.858L7.44 17.618l-1.06-1.06 2.455-2.456zm3.858-3.859L11.3 13.76l-1.061-1.06 2.456-2.456zm3.859-3.859-2.455 2.456-1.06-1.06 2.454-2.456zM21.5 3.5l-2.484 2.542-1.06-1.06L20.5 2.5z"
  })));
};
export default SvgEdgeDashed;